import type { BomStyleOptionLink } from '../../gql';

import { randBoolean, randNumber, randUuid } from '@ngneat/falso';

const mockBomStyleOptionLink = (
    override?: Partial<BomStyleOptionLink>
): BomStyleOptionLink => ({
    documentIndex: randNumber(),
    documentVersion: randNumber(),
    styleOptionNumber: randNumber(),
    isValid: randBoolean(),
    bomDocumentPublicId: randUuid(),
    ...override,
    ['__typename']: 'BomStyleOptionLink',
});

export { mockBomStyleOptionLink };
